import { useState } from 'react';
import { useSelector } from 'react-redux';

import { readSitePreview } from 'helpers/sitePreview';
import { formatCurrency } from 'helpers/formatter';
import useCustomer from 'hooks/useCustomer';
import {
	NALCHIK_STORE_ID,
	NALCHIK_FREE_FLAT_FROM,
	NALCHIK_FREE_DELIVERY_HINT_FROM,
	isNalchikFlatRateQuote,
	cartGoodsSubtotal,
} from 'helpers/nalchikDeliveryZone';

const NalchikFreeDeliveryBar = () => {
	const [sitePreview] = useState(readSitePreview);
	const { customer } = useCustomer();
	const { address, costAddress } = useSelector(
		state => state.layout.deliveryModalData
	);
	const storeInfo = useSelector(state => state.layout.mainInfo.data);
	const cartData = useSelector(state => state.cart.cartProducts.data);

	if (!sitePreview || !address) return null;

	const store = {
		...(storeInfo || {}),
		store_id: storeInfo?.store_id ?? customer?.store_id,
	};
	if (Number(store.store_id) !== NALCHIK_STORE_ID) return null;
	if (!isNalchikFlatRateQuote(costAddress, store)) return null;

	const subtotal = cartGoodsSubtotal(cartData);
	if (subtotal < NALCHIK_FREE_DELIVERY_HINT_FROM) return null;

	const done = subtotal >= NALCHIK_FREE_FLAT_FROM;
	const left = Math.max(0, NALCHIK_FREE_FLAT_FROM - subtotal);
	const pct = Math.max(0, Math.min(100, (subtotal / NALCHIK_FREE_FLAT_FROM) * 100));
	const label = done
		? 'Доставка бесплатно'
		: `Ещё ${formatCurrency(left)} до бесплатной доставки`;

	return (
		<div className={`nalchik-free-delivery${done ? ' is-done' : ''}`}>
			<div className='nalchik-free-delivery-label'>{label}</div>
			<div
				className='nalchik-free-delivery-track'
				role='progressbar'
				aria-valuemin={0}
				aria-valuemax={100}
				aria-valuenow={Math.round(pct)}
				aria-label={label}
			>
				<div className='nalchik-free-delivery-fill' style={{ width: `${pct}%` }} />
			</div>
		</div>
	);
};

export default NalchikFreeDeliveryBar;
